import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

import { Breadcrumbs, Link, Typography } from '@mui/material';
import { NavigateNext } from '@mui/icons-material';

const BreadcrumbsComponent = ({ pageInfo }) => {
    const navigate = useNavigate();
    const theme = useTheme();
    
    return (
        <Breadcrumbs
            separator={<NavigateNext sx={{ color: '#5A1C70' }} />}
            aria-label="breadcrumb"
        >
            {pageInfo && pageInfo.map((page, index) => (
                <>
                    {!page.current && (
                        <Typography
                            key="index"
                            onClick={() => navigate(page.url)}
                            sx={{
                                color: '#5A1C7099',
                                fontFamily: 'Gilroy-Bold',
                                fontSize: '1.5rem',
                                fontWeight: 700,
                                alignSelf: 'center',
                                cursor: 'pointer',
                                '&:hover': {
                                    textDecoration: 'underline',
                                    color: '#5A1C70',
                                },
                                [theme.breakpoints.down(1920)]: {
                                    fontSize: '1.25rem',
                                }
                            }}
                        >
                            {page.name}
                        </Typography>
                    )}
                    {page.current && (
                        <Typography
                            sx={{
                                color: '#5A1C70',
                                fontFamily: 'Gilroy-Bold',
                                fontSize: '1.5rem',
                                fontWeight: 700,
                                alignSelf: 'center',
                                [theme.breakpoints.down(1920)]: {
                                    fontSize: '1.25rem',
                                }
                            }}
                        >
                            {page.name}
                        </Typography>
                    )}
                </>
            ))}
        </Breadcrumbs>
    );
}

export default BreadcrumbsComponent;
